import instance from '../../axios';

export const createRoles = async (data) => {
  const response = await instance.post('roles', data);
  return response.data;
};

export const updateRoles = async (data) => {
  const response = await instance.put(`roles/${data.id}`, data);
  return response.data;
};

export const deleteRoles = async (data) => {
  const id = typeof data === 'object' ? data.id : data;
  const response = await instance.delete(`roles/${id}`);
  return response.data;
};

export const getAllRoles = async () => {
  const response = await instance.get('roles');
  return response.data;
};

export const getRolesById = async (id) => {
  const response = await instance.get(`roles/${id}`);
  return response.data;
};

export const getCurrentRole = async () => {
  const response = await instance.get(`roles/current`);
  return response.data;
};
